import React from 'react'

import Svg from './svg'


export default function Edit2Icon({width, height, color, color2 = '--accent-color', ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-content') || color
    color2 = getComputedStyle(document.documentElement)
        .getPropertyValue(color2) || color2

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="edit2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect id="Combined-Shape" fill={color} x="5" y="5" width="90" height="90" rx="26"></rect>
            <polygon id="Rectangle" fill={color2} transform="translate(59.944151, 39.944151) rotate(-45.000000) translate(-59.944151, -39.944151) " points="26.1052837 32.4441509 106.105284 32.4441509 106.105284 47.4441509 26.1052837 47.4441509 13.7830181 39.9441509"></polygon>
            <path d="M81.2309858,8.05071425 L87.2817001,2 L97.8883018,12.6066017 L91.871125,18.6237785 C89.4404414,14.1413694 85.7304736,10.45376 81.2309858,8.05071425 Z" id="Combined-Shape" fill={color}></path>
        </g>
    </Svg>
}
